import { useNavigate } from 'react-router-dom'
import Button from '../components/common/Button'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="w-full max-w-[400px] mx-auto flex-1 flex flex-col justify-center">
      <p className="text-label font-semibold uppercase text-ink-3">Error 404</p>

      <h1 className="mt-2 font-display font-bold text-display-l text-ink">
        This road goes nowhere.
      </h1>

      <p className="mt-2.5 text-body text-ink-2">
        The page you asked for is not here. The delivery services are.
      </p>

      <Button onClick={() => navigate('/home')} className="mt-6 self-start">
        Browse services
      </Button>
    </div>
  )
}
